import { ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/app/components/ui/dropdown-menu';

interface CategoryDropdownProps {
  categories: string[];
  selected: string;
  onSelect: (category: string) => void;
}

export function CategoryDropdown({ categories, selected, onSelect }: CategoryDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="px-4 py-2.5 rounded-lg text-sm font-medium transition-all bg-black text-white hover:bg-[#1a1a1a] border border-[#9595a5]/30 flex items-center gap-2 whitespace-nowrap">
          {selected}
          <ChevronDown className="w-4 h-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-black border-[#9595a5]/30 text-white min-w-[160px]">
        {categories.map((category) => (
          <DropdownMenuItem
            key={category}
            onClick={() => onSelect(category)}
            className={`cursor-pointer px-4 py-2 text-sm transition-all ${
              selected === category
                ? 'bg-white/20 text-white'
                : 'text-[#9595a5] hover:text-white hover:bg-[#1a1a1a]'
            }`}
          >
            {category}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
